<template>
  <div class="events">
    <AppTable
      v-if="tableData.length"
      :fields="tableFields"
      :items="tableData"
    >
      <template #name="data">
        <BaseLink :href="`/events/${data.eventId}`">
          {{ data.name }}
        </BaseLink>
      </template>
    </AppTable>

    <p v-else class="h3">Список событий пуст.</p>
  </div>
</template>

<script>
import AppTable from '@/components/AppTable'
import BaseLink from '@/components/Base/BaseLink'

export default {
  name: 'AppEvents',
  components: {
    BaseLink,
    AppTable
  },
  data () {
    return {
      tableFields: [
        { key: 'name', label: 'Название', sortable: true, slot: true },
        { key: 'creator', label: 'Создатель', sortable: true },
        { key: 'login', label: 'Логин', sortable: true },
        { key: 'members', label: 'Количество участников', sortable: true },
        { key: 'date', label: 'Дата создания', sortable: true }
      ],
      tableData: []
    }
  },
  created () {
    this.fetchEvents()
  },
  methods: {
    async fetchEvents () {
      try {
        const { data } = await this.$api.user.events(this.$route.params.id)
        const list = data?.list ?? []

        this.tableData = list.map(item => {
          const eventId = item?.id ?? ''
          const name = item?.title ?? ''
          const userName = item?.createdBy.name ?? ''
          const userSurname = item?.createdBy.surname ?? ''
          const login = item?.createdBy.username ?? ''
          const members = item?.countMember ?? ''
          const date = item?.start ?? ''

          return {
            eventId,
            name,
            creator: `${userName} ${userSurname}`,
            login,
            members,
            date
          }
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.events {}
</style>
